const CAMPAIGNS = [
    {
        title: 'Neighborhood farming',
        description:
            'Own your farm with recurring drops to the streets and ZIPs where you want to be the agent everyone knows.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'map-pin',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Just listed & just sold',
        description:
            'Auto-fire mail to nearby homes the day you list or close - turn every listing and sale into another farm touch.',
        iconBg: 'bg-[#FAB331]/20',
        iconColor: 'text-secondary',
        icon: 'home',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Expired & withdrawn listings',
        description:
            'Reach owners whose listings expired with another agent - auto-fired the moment a listing falls off the market.',
        iconBg: 'bg-[#DBEAFE]',
        iconColor: 'text-[#1E40AF]',
        icon: 'refresh',
        badge: 'Auto-trigger ready',
    },
    {
        title: 'Market update mailers',
        description:
            'Monthly or quarterly neighborhood reports that build authority and keep your name attached to local market data.',
        iconBg: 'bg-[#DCFCE7]',
        iconColor: 'text-[#166534]',
        icon: 'trend',
    },
    {
        title: 'Sphere & past-client touches',
        description:
            'Keep your name in front of past clients, referrals, and COI with sequenced drops that earn the next listing.',
        iconBg: 'bg-secondary/10',
        iconColor: 'text-secondary',
        icon: 'users',
    },
    {
        title: 'Open house mailers',
        description:
            'Drive neighbors and prospective buyers to your open house with timely invitations that hit before showing day.',
        iconBg: 'bg-gray-200',
        iconColor: 'text-gray-600',
        icon: 'calendar',
    },
]

const ADD_ONS = [
    {
        title: 'Call tracking numbers',
        description: 'Unique numbers per campaign, list, or drop.',
        icon: 'phone',
    },
    {
        title: 'QR code tracking',
        description: 'Tie scans back to the exact mail piece and offer.',
        icon: 'qr',
    },
    {
        title: 'Delivery tracking',
        description: 'See when mail hits the box, not just when it ships.',
        icon: 'truck',
    },
    {
        title: 'Campaign reporting',
        description: 'Compare lists, offers, and creative drop over drop.',
        icon: 'chart',
    },
]

function CampaignIcon({ name, className }) {
    const icons = {
        home: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
        ),
        'map-pin': (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
            </svg>
        ),
        refresh: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M12 6v6h4.5" />
                <path d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
        ),
        trend: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="m2.25 18 6.75-6.75 4.306 4.306a11.95 11.95 0 0 1 5.814-5.518l2.74-1.22" />
                <path d="m15.92 6.538 5.94 2.28-2.28 5.941" />
            </svg>
        ),
        users: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M15 19.128A9.38 9.38 0 0 0 17.625 19.5a9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493" />
                <path d="M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07" />
                <path d="M15 19.234A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07" />
                <path d="M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Z" />
                <path d="M18.75 11.25a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z" />
            </svg>
        ),
        calendar: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12" />
                <path d="M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75" />
                <path d="M8.25 21h8.25" />
            </svg>
        ),
    }
    return icons[name] || null
}

function AddOnIcon({ name, className }) {
    const icons = {
        phone: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102A1.125 1.125 0 0 0 5.872 2.25H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
            </svg>
        ),
        qr: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5Z" />
                <path d="M3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5Z" />
                <path d="M13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z" />
                <path d="M6.75 6.75h.75v.75h-.75v-.75Zm0 9.75h.75v.75h-.75v-.75Zm9.75-9.75h.75v.75h-.75v-.75Zm-3 6.75h.75v.75h-.75v-.75Zm0 6h.75v.75h-.75v-.75Zm6-6h.75v.75h-.75v-.75Zm0 6h.75v.75h-.75v-.75Zm-3-3h.75v.75h-.75v-.75Z" />
            </svg>
        ),
        truck: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M8.25 18.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm11.25 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
                <path d="M8.25 18.75h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25" />
                <path d="M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
            </svg>
        ),
        chart: (
            <svg
                className={className}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round">
                <path d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75Z" />
                <path d="M9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625Z" />
                <path d="M16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z" />
            </svg>
        ),
    }

    return icons[name] || null
}

function SparklesIcon({ className }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill="none"
            width={12}
            height={12}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"></path>
        </svg>
    )
}

export default function CampaignStrategy() {
    return (
        <section className="bg-white">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8 lg:py-28">
                <div className="mb-10 flex max-w-3xl flex-col gap-4">
                    <span className="text-xs font-semibold uppercase tracking-widest text-secondary">
                        Agent campaign strategy
                    </span>
                    <h2
                        className="text-3xl font-bold tracking-tight text-[#3f454f] md:text-[44px]"
                        style={{ lineHeight: 1.05 }}>
                        Direct mail built around the listings you actually want
                        more of.
                    </h2>
                    <p
                        className="text-lg text-[color-mix(in_oklab,_#3F454F_70%,_transparent)]"
                        style={{ lineHeight: '28px' }}>
                        Stay top-of-mind in your farm, reach motivated
                        homeowners when life events hint at a move, and turn
                        every listing and sale into another touch in the
                        neighborhood.
                    </p>
                </div>

                <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-5">
                    {CAMPAIGNS.map((campaign, i) => (
                        <div
                            key={i}
                            className="group relative flex flex-col gap-4 rounded-2xl border border-gray-200/50 bg-[#FFF7EC] p-6 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl lg:p-7">
                            <div
                                className={
                                    campaign.badge
                                        ? 'flex flex-row items-start justify-between gap-3'
                                        : ''
                                }>
                                <div
                                    className={`flex h-12 w-12 items-center justify-center rounded-xl ${campaign.iconBg} transition-transform duration-300 ease-out group-hover:scale-110 group-hover:rotate-3`}>
                                    <CampaignIcon
                                        name={campaign.icon}
                                        className={`h-6 w-6 ${campaign.iconColor}`}
                                    />
                                </div>
                                {campaign.badge && (
                                    <div className="mt-2 -mr-2 -mt-2 flex flex-row items-center gap-1 rounded-full border border-secondary/30 bg-transparent px-2 py-px">
                                        <SparklesIcon className="h-3 w-3 text-secondary" />
                                        <span className="text-[0.625rem] font-bold uppercase leading-7 tracking-wider text-secondary">
                                            {campaign.badge}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <h3
                                className="text-lg font-bold text-[#3F454F] md:text-[22px]"
                                style={{ lineHeight: '28px' }}>
                                {campaign.title}
                            </h3>
                            <p
                                className="text-sm text-[color-mix(in_oklab,_#3F454F_65%,_transparent)]"
                                style={{ lineHeight: 1.625 }}>
                                {campaign.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mx-auto max-w-7xl px-6 pb-20 lg:px-8 lg:pb-28">
                <div className="rounded-3xl border border-black/10 bg-[#FFF7EC] px-8 py-7 lg:px-12 lg:py-8">
                    <div className="mb-5 text-xs font-bold uppercase tracking-wider text-[#ed5c2f]">
                        Available add-ons for any order
                    </div>
                    <div className="grid grid-cols-1 gap-6 lg:grid-cols-4 lg:gap-8">
                        {ADD_ONS.map((addOn) => (
                            <div
                                key={addOn.title}
                                className="flex flex-row items-start gap-4">
                                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-sm">
                                    <AddOnIcon
                                        name={addOn.icon}
                                        className="h-5 w-5 text-[#ed5c2f]"
                                    />
                                </div>
                                <div className="flex flex-col gap-1">
                                    <div className="font-bold text-[#3F454F]">
                                        {addOn.title}
                                    </div>
                                    <div className="text-sm leading-relaxed text-[#3F454F]/65">
                                        {addOn.description}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}
